import Typography from '@mui/material/Typography'

import Button from 'app/shared-components/Button'
import Card from 'app/shared-components/Card'
import useLabel from 'app/hooks/useLabel'

import useStyles from './PrintLabelOverview.style'

type Props = {
    printLabel: () => void
}

const PrintLabelOverview = ({
    printLabel,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    return (
        <Card>
            <Typography variant="h3">
                {l('LABEL_PRINTING')}
            </Typography>
            <div className={classes.containerBtn}>
                <Button
                    className={classes.btnControl}
                    label={l('PRINT_LABEL')}
                    isUpperCase={false}
                    onClick={printLabel}
                />
            </div>
        </Card>
    )
}

export default PrintLabelOverview
